import { CameraCreationItem, CameraConnectionStatus } from '@/types/camera';
import { AddCameraModalSidebar } from './AddCameraModalSidebar';
import { AddCameraModalConfiguration } from './AddCameraModalConfiguration';

interface AddCameraModalContentProps {
    cameras: CameraCreationItem[];
    activeCameraId: string | null;
    onCameraSelect: (id: string) => void;
    onAddCamera: () => void;
    onDeleteCamera: (id: string) => void;
    onCameraUpdate: (
        cameraId: string,
        updates: Partial<CameraCreationItem>,
    ) => void;
    onValidationChange: (cameraId: string, valid: boolean) => void;
    connectionStatus: Record<string, CameraConnectionStatus>;
    onRetryConnection: () => void;
    triggerValidation?: number;
    addDisabled?: boolean;
    atCapHint?: string;
}

export function AddCameraModalContent({
    cameras,
    activeCameraId,
    onCameraSelect,
    onAddCamera,
    onDeleteCamera,
    onCameraUpdate,
    onValidationChange,
    connectionStatus,
    onRetryConnection,
    triggerValidation,
    addDisabled,
    atCapHint,
}: AddCameraModalContentProps) {
    const activeCamera = cameras.find((camera) => camera.id === activeCameraId);
    const activeCameraConnectionStatus = activeCameraId
        ? connectionStatus[activeCameraId]
        : undefined;

    return (
        <div className="flex gap-0 h-full">
            <AddCameraModalSidebar
                cameras={cameras}
                activeCameraId={activeCameraId}
                onCameraSelect={onCameraSelect}
                onAddCamera={onAddCamera}
                onDeleteCamera={onDeleteCamera}
                connectionStatus={connectionStatus}
                addDisabled={addDisabled}
                atCapHint={atCapHint}
            />
            <div className="w-px bg-grey-500 flex-shrink-0 h-full" />
            <div className="flex-1 overflow-y-auto px-4 py-4 scrollbar-hide">
                {activeCamera && (
                    <AddCameraModalConfiguration
                        camera={activeCamera}
                        onCameraUpdate={onCameraUpdate}
                        onValidationChange={onValidationChange}
                        connectionStatus={activeCameraConnectionStatus}
                        onRetryConnection={onRetryConnection}
                        triggerValidation={triggerValidation}
                    />
                )}
            </div>
        </div>
    );
}
